import React from 'react';
import {SimpleGrid} from 'src/design/atoms/SimpleGrid';
import {IconFolder, IconLayoutGrid} from '@tabler/icons-react';
import type {FormDefinitionCategoryCountsResponse} from 'src/api/ProactApiClient';
import {StatCard} from 'src/design/molecules/StatCard';

export interface MyFormsCategoryCardsProps {
  counts: FormDefinitionCategoryCountsResponse | undefined;
  activeCategoryId: number | undefined;
  onSelectCategory: (categoryId: number | undefined) => void;
}

const CARD_COLOR = 'blue';

export const MyFormsCategoryCards: React.FC<MyFormsCategoryCardsProps> = ({
  counts,
  activeCategoryId,
  onSelectCategory,
}) => {
  if (!counts || counts.categories.length === 0) return null;

  return (
    <SimpleGrid cols={{base: 2, sm: 3, md: 6}} mb="md">
      <StatCard
        title="All"
        count={counts.total}
        icon={<IconLayoutGrid size={18} />}
        color={CARD_COLOR}
        isActive={activeCategoryId === undefined}
        onClick={() => onSelectCategory(undefined)}
      />
      {counts.categories.map(category => (
        <StatCard
          key={category.id}
          title={category.name}
          count={category.count}
          icon={<IconFolder size={18} />}
          color={CARD_COLOR}
          isActive={activeCategoryId === category.id}
          onClick={() =>
            onSelectCategory(
              activeCategoryId === category.id ? undefined : category.id
            )
          }
        />
      ))}
    </SimpleGrid>
  );
};
